module.exports = __webpack_public_path__ + "static/media/_empty.792a3260.jpg";